import React from "react";
import { Icon, Typography } from "@plum-xoxo/admin-dsm";
import { Link } from "react-router-dom";
import { app_path } from "config";
const PageHeader = ({
  title = "",
  subtitle = "",
  className = "",
  showBackButton = false,
  bottomMargin = "mb-0",
}) => {
  return (
    <div className={className + " d-flex align-items-center"}>
      <div>
        {showBackButton && (
          <Link className="cursor-pointer" to={`/${app_path}/reports`}>
            <Icon className="mr-20" iconName="PlumBack" />
          </Link>
        )}
      </div>
      <div>
        <Typography.H2 color="dark" shade="c300">
          {title}
        </Typography.H2>
        {/* {subtitle && (
          <Typography.BodySemiBold
            component="div"
            color="dark"
            shade="c200"
            className={bottomMargin}
          >
            {subtitle}
          </Typography.BodySemiBold>
        )} */}
      </div>
    </div>
  );
};

export default PageHeader;
